var map = {
	"./cnn-money-x2.png": 2038,
	"./cnn-money.png": 2243,
	"./economist-x2.png": 2039,
	"./economist.png": 2244,
	"./mashable-x2.png": 2040,
	"./mashable.png": 2245,
	"./tech-crunch-x2.png": 2041,
	"./tech-crunch.png": 2246,
	"./thenewyorker-x2.png": 2042,
	"./thenewyorker.png": 2247,
	"./thrillist-x2.png": 2043,
	"./thrillist.png": 2248,
	"./time-x2.png": 2044,
	"./time.png": 2249,
	"./usa-today-x2.png": 2045,
	"./usa-today.png": 2250
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2242;